import DOMPurify from "dompurify";

const Rte = ({ xmlString }: { xmlString: string }) => (
  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(xmlString) }} />
);

export default Rte;
